import { useCallback } from "react";

import { useMutation } from "@apollo/client";
import { message } from "antd";

import { renderErrorMessage } from "Services/LoggingService";

import {
    upsertEventDefinitionMutation as UPSERT_EVENT_DEFINITION_MUTATION,
    UpsertEventDefinitionInput,
} from "../mutations";

type HookReturn = {
    upsertEventDefinition: (upsert: UpsertEventDefinitionInput) => Promise<void>;
    isMutating: boolean;
};

export function useEventDefinitionMutation(): HookReturn {
    const [upsertEventDefinitionMutation, { loading: isUpserting }] = useMutation(UPSERT_EVENT_DEFINITION_MUTATION);

    // Call backs to invoke server side mutations
    const upsertEventDefinition = useCallback(
        async (upsert: UpsertEventDefinitionInput) => {
            try {
                await upsertEventDefinitionMutation({
                    variables: {
                        upsert,
                    },
                });
                message.success(`Successfully Updated Event.`);
            } catch (e) {
                renderErrorMessage({
                    content: "Failed to update event",
                    error: e as Error,
                });
            }
        },
        [upsertEventDefinitionMutation]
    );

    return {
        isMutating: isUpserting,
        upsertEventDefinition,
    };
}
